export default __webpack_public_path__ + "static/media/dahlia.e7f1e06d.jpg";